import { createSlice } from "@reduxjs/toolkit";
import { act } from "react-dom/test-utils";

export interface ReportsState {
  isFetchingReportsData: boolean,
  isExportReport: boolean;
  allReportsList: [],
  allReportsByGroup: {},
  logEntity: {},
}

const initialState: ReportsState = {
  isFetchingReportsData: false,
  isExportReport: false,
  allReportsList: [],
  allReportsByGroup: {},
  logEntity: {}
}

export const reportsSlice = createSlice({
  name: 'business',
  initialState,
  reducers: {
    getAllReportsData: (state) => {
      state.isFetchingReportsData = true;
    },
    saveAllReportsData: (state, actions) => {
      state.allReportsList = actions.payload?.reportList;
      state.isFetchingReportsData = false;
    },
    saveReportDataByGroup: (state, action) => {
      state.allReportsByGroup = action.payload;
    },
    exportReportData: (state, action) => {
      state.isExportReport = true;
    },
    getLogEntity: () => {},
    saveLogEntity: (state,action) => {
      state.logEntity = action.payload;
    },
    getAuditLogs: (state,action) => {}
  }
})

export const {
  getAllReportsData,
  saveAllReportsData,
  saveReportDataByGroup,
  exportReportData,
  getLogEntity,
  saveLogEntity,
  getAuditLogs,
} = reportsSlice.actions;
export default reportsSlice.reducer;